<template>
  <div>
    <div v-if="values">
      <b-form-group>
        <label class="mb-0 pb-0">Opacity</label>
        <div class="flex w-100 items-center gap-[10px]">
          <vue-slider
            v-model="values.value"
            :dot-size="17"
            :interval="0.1"
            :max="1"
            :min="0"
            class="editor-slider-2 w-100"
            tooltip="none"
          />

          <NumberControl
            v-model="values.value"
            class="d-block !w-[60px]"
          />
        </div>
      </b-form-group>

      <span
        v-if="progress !== 0 && progress !== 100"
        class="mt-[-10px] block mb-3 text-[#333333] underline text-[13px] cursor-pointer hover:opacity-80 line-height-[13px]"
        @click="removePoint"
      >
        Remove
      </span>
    </div>

    <button
      v-else
      class="bg-[#007bff] rounded-[4px] text-white w-[105px] p-0 m-0 h-[38px] mb-3"
      @click="addPoint"
    >
      Add Point
    </button>
  </div>
</template>

<script>
import _ from 'lodash'
import MotionEffectMixin from '@/mixins/MotionEffectMixin'
import NumberControl from '@/components/editor/components/NumberControl'
export default {
  name: 'MotionOpacity',
  components: {NumberControl},
  mixins: [MotionEffectMixin],
  props: {
    progress: {
      type: Number,
      required: true
    },
    motion: {
      type: Object,
      required: true
    }
  },
  computed: {
    values: {
      get () {
        return _.find(this.motion.values, ['progress', this.progress])
      }
    }
  }
}
</script>